<template>
  <div class="full">
    <!-- <div class="full" v-else-if="nologin">
      <LoginUI></LoginUI>
    </div>
     -->
    <slot class="full" v-if="ready"></slot>

  </div>
</template>

<script>
import { State, waitHydration, waitTilLoggedIn, onEmailLinkArrive } from '../game/auth.js'

export default {
  components: {
  },
  data () {
    return {
      ready: false,
      // resolved: false,
      nologin: false
    }
  },
  mounted () {
    this.$emit('status', 'loader')
    waitHydration().then(() => {
      if (!State.user) {
        this.$emit('status', 'nologin')
        // this.nologin = true

        onEmailLinkArrive({
          silent: true,
          canWait: () => {
            this.$emit('status', 'loader')
          }
        })
      }
      // this.resolved = true
    })
    waitTilLoggedIn().then(() => {
      this.init()
    })
  },
  methods: {
    init () {
      this.ready = true
      this.$emit('status', 'ready')
      this.$emit('onReady')
    }
  }
}
</script>

<style>

</style>
